import { ViewModeWidgetTitle, WidgetTitleWithInfo } from './WidgetTitle';
import { WidgetHeaderBar } from './WidgetHeaderBar';
import { WithPopover } from '@ardoq/popovers';
import { Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';

interface MetricsModeHeaderBarProps {
  name: string;
  infoMessage?: string;
}
export const MetricsModeHeaderBar = ({
  name,
  infoMessage,
}: MetricsModeHeaderBarProps) => (
  <WidgetHeaderBar>
    {infoMessage ? (
      <ViewModeWidgetTitle>
        <WidgetTitleWithInfo>
          <span>{name}</span>
          <WithPopover content={infoMessage}>
            <Icon iconName={IconName.INFO} style={{ color: colors.icon }} />
          </WithPopover>
        </WidgetTitleWithInfo>
      </ViewModeWidgetTitle>
    ) : (
      <ViewModeWidgetTitle>{name}</ViewModeWidgetTitle>
    )}
  </WidgetHeaderBar>
);
